import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/bootstrap-vue";
import "./plugins/vee-validate";
import Notifications from "vue-notification";
import MemberInfo from "@/components/membership/MemberInfo";
import moment from "moment";
import dayJs from "./plugins/dayjs";
import VueMomentJS from "vue-momentjs";
import "moment/locale/ko";
import VueAppleLogin from "vue-apple-login";
import VideoPlayer from "vue-video-player";
import i18n from "./i18n";

// 구글맵
import * as VueGoogleMaps from "vue2-google-maps";

// import "./assets/css/common.css";
// import "./assets/css/style.css";
// import "./assets/css/brs.css";

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(VideoPlayer);
Vue.use(VueMomentJS, moment);
Vue.use(Notifications);
Vue.use(dayJs);
Vue.component("MemberInfo", MemberInfo);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBAtovuJKbsiCMgWJ11BlgFwIvkNvyPTAs",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
});

Vue.use(VueAppleLogin, {
  clientId: process.env.VUE_APP_SOCIAL_APPLE_CLIENT_ID,
  scope: "name email",
  redirectURI: "https://agw.thegolf.com/login",
  state: process.env.VUE_APP_SOCIAL_APPLE_CLIENT_ID,
  usePopup: true,
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
